const initialState =
{
    data: [],
    saving: false,
};

export default (state = initialState, action) => {

    switch(action.type) {

        case 'DESCUENTOS_LIST':
            return {
                ...state,
                data: action.payload
            };
        case 'DESCUENTOS_UPDATE_SUCCESS':
            let newp = action.payload;
            return {
                ...state,
                saving: false,
                data: state.data.map((d, i) => { return (d.id == newp.id) ? newp : d })
            }
        default:
            return state;
    }
    
};


// WEBPACK FOOTER //
// ./src/reducers/descuentos.js